import { render, staticRenderFns } from "./RateControl.vue?vue&type=template&id=20778c4b&scoped=true&"
import script from "./RateControl.vue?vue&type=script&lang=js&"
export * from "./RateControl.vue?vue&type=script&lang=js&"
import style0 from "./RateControl.vue?vue&type=style&index=0&id=20778c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20778c4b",
  null
  
)

export default component.exports